/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { createContext, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './services/serviceWorkers/serviceWorker';
import App from './App';
import Home from './scenes/Home';
import './index.css';
import config from '../public/conf/config.json';
import 'antd/dist/reset.css';
import Localizer from './components/Localizer';
import TariffBreakdown from './scenes/TariffBreakdown';
import SelfMeterReading from './scenes/SelfMeterReading';

// Create context for URL parameters
export const URLParamsContext = createContext();

const URLParamsProvider = ({ children }) => {
  const [showNavbar, setShowNavbar] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const navbarParam = urlParams.get('navbar');

    // Handle navbar visibility
    if (navbarParam === 'false') {
      setShowNavbar(false);
    }
  }, []);

  return (
    <URLParamsContext.Provider value={{ showNavbar }}>
      {children}
    </URLParamsContext.Provider>
  );
};
const root = createRoot(document.getElementById('root'));

if (window.location.pathname === '/' || window.location.pathname === '') {
  const basePath = `/${config.appName}`;
  if (window.location.pathname !== basePath) {
    window.history.replaceState(null, '', basePath);
  }
}

const routes = [
  {
    path: `/${config.appName}/tariff-breakdown`,
    component: TariffBreakdown,
    title: 'Tariff Breakdown',
    exact: true,
  },
  {
    path: `/${config.appName}/self-reading/:requestId`,
    component: SelfMeterReading,
    title: 'Self Meter Reading',
    exact: true,
  },
  {
    path: `/${config.appName}`,
    exact: false,
    component: Home,
    title: config.defaultAppTitle,
  },
];

root.render(
  <URLParamsProvider>
    <Localizer>
      <App routes={routes} />
    </Localizer>
  </URLParamsProvider>,
);

// If you want your app e and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
